<template>
  <div id="app">
    <div>
      <header>
        <h1>Law Office of Jacob Unger</h1>
        <p>5404 Whitsett Ave., Suite 182, Valley Village, CA 91607</p>
        <p><fa-icon icon="phone" />&nbsp;<a href="tel:+818-960-0295">(818) 960-0295</a> • <fa-icon icon="fax" /> (818) 960-0296 • <fa-icon icon="envelope"/>&nbsp;<a href="mailto:junger@jacobungerlaw.com">junger@jacobungerlaw.com</a></p>
      </header>
    

      <img src="./assets/construction.png">
      <h3>
        
        This website is under construction.
      </h3>

    </div>
  </div>
</template>

<script>


export default {
  name: 'app'
}
</script>

<style>
* {
margin: 0;
padding: 0;
}
header {
  padding-top: 60px;
  padding-bottom: 40px;
  margin-bottom: 60px;
  background: lightblue;
}
header > p {
  padding: .5em;
}
img {
  width: 100px;
  height: auto;
  margin-bottom: 60px;
  vertical-align: middle;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
